import { render, staticRenderFns } from "./CourseActivitySelectbox.vue?vue&type=template&id=289e60cf"
import script from "./CourseActivitySelectbox.vue?vue&type=script&lang=js"
export * from "./CourseActivitySelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports